// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_2e-3";
export var dialog = "_2e-0";
export var divClassnameSwatch = "_2e-8";
export var flexSwatch = "_2e-4";
export var header = "_2e-1";
export var styleAttributeSwatch = "_2e-7";
export var swatch = "_2e-2";
export var textHeaderSwatch = "_2e-5";
export var webSwatch = "_2e-6";